import { InformationBanner } from 'src/components/molecules';
import styled from 'styled-components';

interface TextBoxProps {
  disabled: boolean;
}
export const Header = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid
    ${(props) => props.theme.atlas.semantic.color.ui.divider.default};
  padding: 0px 30px 32px 32px;
`;

export const Title = styled.h2`
  display: block;
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  font-size: 20px;
  font-weight: 500;
  margin-bottom: 10px;
`;

export const AddUserText = styled.p`
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  font-size: 14px;
  font-weight: 400;
  color: ${(props) => props.theme.atlas.semantic.color.type.disabled};
  margin: 0 8px 0 0;
`;

export const SwitchContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const BannerContainer = styled.div`
  margin-top: 20px;
`;

export const Select = styled.select`
  width: max-content;
  cursor: pointer;
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 14px;
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  padding: 6px 32px 6px 12px;
  border-radius: 8px;
  border: 1px solid
    ${(props) => props.theme.atlas.semantic.color.ui.divider.default};
  appearance: none;
  background-image: url('/assets/manualIntake/expandDropdown.svg');
  background-repeat: no-repeat;
  background-position: calc(100% - 10px) center;
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  padding: 32px 32px 40px 32px;
  min-height: 450px;
`;

export const Footer = styled.div`
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 40px;
`;

export const AnonymousContainer = styled.div`
  display: flex;
  justify-content: center;
  column-gap: 8px;
  margin-bottom: 30px;
  align-items: center;
`;

export const AnonymousText = styled.p`
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  font-weight: 400;
  font-size: 14px;
`;

export const SubTitle = styled.h3`
  width: auto;
  font-weight: 500;
  font-size: 14px;
  line-height: 16px;
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
`;

export const TextBox = styled.div<TextBoxProps>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  border: ${(props) =>
    `1px solid ${props.theme.atlas.semantic.color.outline.default}`};
  border-radius: 4px;
  padding: 8px;
  margin-bottom: 20px;
  background-color: ${(props) =>
    props.disabled && props.theme.atlas.semantic.color.surface.variant};
`;

export const ExteralReporterContainer = styled.div`
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
`;

export const TextInput = styled.input`
  border: none;
  outline: none;
  font-weight: 300;
  font-size: 14px;
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  background-color: ${(props) =>
    props.disabled && props.theme.atlas.semantic.color.surface.variant};
  flex: 1;
  &:disabled {
    &::placeholder {
      color: ${(props) => props.theme.atlas.semantic.color.outline.default};
    }
  }
`;

export const ExplainerText = styled.p`
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
  font-family: ${(props) =>
    props.theme.atlas.typography.semantic.bodySmall.fontFamily};
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
`;

export const Padding = styled.div`
  height: 20px;
`;

export const StyledInformationBanner = styled(InformationBanner)`
  margin-top: 20px;
`;
